import { render, staticRenderFns } from "./CurrencyField.vue?vue&type=template&id=68f71fa0&scoped=true&"
import script from "./CurrencyField.vue?vue&type=script&lang=js&"
export * from "./CurrencyField.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyField.vue?vue&type=style&index=0&id=68f71fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f71fa0",
  null
  
)

component.options.__file = "CurrencyField.vue"
export default component.exports